import { useUnavailableQuestionnaireTypesQuery } from "../../../../../../api/graphql/queries/questionnaire/unavailableQuestionnaireTypes.generated";
import { QuestionnaireType } from "../../../../../../api/graphql/schema.generated";

const NO_UNAVAILABLE_TYPES: QuestionnaireType[] = [];

type Params = {
  email: string | null | undefined;
  taxYear: number;
  skip?: boolean;
};

/**
 * Questionnaire types the backend says the customer cannot fill in (e.g. a
 * company has no private or business year-end questionnaires). The rule lives
 * in the backend; the Backoffice only asks. `network-only` so that a legal
 * form change shows on the next page load instead of a stale cache entry.
 */
const useUnavailableQuestionnaireTypes = ({ email, taxYear, skip }: Params) => {
  const { data, loading } = useUnavailableQuestionnaireTypesQuery({
    skip: skip || !email,
    fetchPolicy: "network-only",
    variables: { email: email!, year: taxYear },
  });

  return {
    unavailableTypes:
      data?.unavailableQuestionnaireTypes ?? NO_UNAVAILABLE_TYPES,
    loading,
  };
};

export default useUnavailableQuestionnaireTypes;
